<main class="container-geral d-flex flex-column gap-4">
  <section class="cabecalho">
    <h1 class="titulo">
      {{ operacaoId
        ? ('COMPONENTS.TAXAS_MAPA_FORM.titleUpdate' | transloco)
        : ('COMPONENTS.TAXAS_MAPA_FORM.titleCreate' | transloco)
      }}
    </h1>
  </section>

  <section class="form-section">
    <p class="paragrafo-informacoes">
      {{ 'COMPONENTS.TAXAS_MAPA_FORM.info' | transloco }}
    </p>

    <div class="formulario">
      <form class="group-form" [formGroup]="formularioTaxaIdeal" (ngSubmit)="onSubmit()">
        <div class="row">
          <div class="col-md-4 mb-4">
            <label class="form-label">
              {{ 'COMPONENTS.TAXAS_MAPA_FORM.plantLabel' | transloco }}
            </label>

            <app-loading *ngIf="loading"></app-loading>

            <select *ngIf="!loading" formControlName="fk_cliente" class="crud-select form-select input-form form-control" (change)="buscarItensCliente()">
              <option value="" disabled>
                {{ 'COMPONENTS.TAXAS_MAPA_FORM.plantPlaceholder' | transloco }}
              </option>

              @for (cliente of clientes; track cliente.id) {
                <option [value]="cliente.id">{{ cliente.nome }}</option>
              }
            </select>
          </div>

          <div class="col-md-4 mb-4">
            <label class="form-label">
              {{ 'COMPONENTS.TAXAS_MAPA_FORM.operationLabel' | transloco }}
            </label>

            <app-loading *ngIf="loadingOperacoes"></app-loading>

            <select *ngIf="!loadingOperacoes" formControlName="fk_operacao" class="crud-select form-select input-form form-control" #operacoes
              (change)="operacaoId
                ? atualizarTaxasOperacaoEdicao(operacoes.value)
                : atualizarTaxasOperacao()"
            >
              <option selected disabled>
                {{ operacoesDisponiveis
                  ? ('COMPONENTS.TAXAS_MAPA_FORM.operationPlaceholder' | transloco)
                  : ('COMPONENTS.TAXAS_MAPA_FORM.noOperation' | transloco)
                }}
              </option>

              @for (op of operacoesDisponiveis; track op.sr_id) {
                <option [value]="op.sr_id">{{ op.vc_service_id }}</option>
              }
            </select>
          </div>

          <div class="col-md-4 mb-4">
            <label class="form-label">
              {{ 'COMPONENTS.TAXAS_MAPA_FORM.ratesLabel' | transloco }}
            </label>

            <app-loading *ngIf="loadingTaxas"></app-loading>

            <mat-select *ngIf="!loadingTaxas" formControlName="taxas_selecionadas" multiple class="crud-select form-select input-form" [placeholder]="taxasOperacao.length
                ? ('COMPONENTS.TAXAS_MAPA_FORM.ratesPlaceholder' | transloco)
                : ('COMPONENTS.TAXAS_MAPA_FORM.noRates' | transloco)"
            >
              @for (taxa of taxasOperacao; track taxa.dado) {
                <mat-option [value]="taxa.dado">
                  {{ 'ENUMS.taxas_short.' + taxa.dado | transloco }}
                </mat-option>
              }
            </mat-select>
          </div>
        </div>

        <div class="taxas-container">
          <div *ngFor="let taxa of taxasSelecionadas" class="row">
            <p class="paragrafo-informacoes">
              {{ 'ENUMS.taxas.' + taxa.tipo | transloco }}
            </p>

            <div class="col-md-6 mb-4">
              <label class="form-label">
                {{ 'GRANDEZAS.' + taxa.grandeza | transloco }}
                {{ 'COMPONENTS.TAXAS_MAPA_FORM.minimumLabel' | transloco }}
                ({{ 'UNITS.' + taxa.unidade | transloco }})
              </label>

              <input type="number" class="input-form form-control" [formControlName]="'fl_minimo_aceitavel_' + taxa.tipo" required/>
            </div>

            <div class="col-md-6 mb-4">
              <label class="form-label">
                {{ 'GRANDEZAS.' + taxa.grandeza | transloco }}
                {{ 'COMPONENTS.TAXAS_MAPA_FORM.idealLabel' | transloco }}
                ({{ 'UNITS.' + taxa.unidade | transloco }})
              </label>

              <input type="number" class="input-form form-control" [formControlName]="'fl_ideal_' + taxa.tipo" required/>

              <small class="mensagem-validacao-form" *ngIf="taxa.erro">
                {{ 'COMPONENTS.TAXAS_MAPA_FORM.idealGreaterThanMinimum' | transloco }}
              </small>
            </div>
          </div>
        </div>

        <div class="buttons-form d-flex">
          <button type="button" class="btn-cancelar" (click)="cancelar()">
            {{ 'COMPONENTS.TAXAS_MAPA_FORM.cancelButton' | transloco }}
          </button>

          <button type="submit" class="btn-confirmar" [disabled]="botaoDesabilitado">
            {{ operacaoId
              ? ('COMPONENTS.TAXAS_MAPA_FORM.updateButton' | transloco)
              : ('COMPONENTS.TAXAS_MAPA_FORM.createButton' | transloco)
            }}
          </button>
        </div>
      </form>
    </div>
  </section>
</main>
